import { Api } from "@relode/core";

import { LeadJobDetailPublicResponse } from ".";

export const candidatePublicService = {
    getCandidatePublicDetails: async (
        token: string,
        signal?: AbortSignal
    ): Promise<LeadJobDetailPublicResponse> => {
        const url = `/public/candidates?token=${token}`;
        const result = await Api.url(url)
            .retries(3)
            .useSignal(signal)
            .track({ name: "getCandidatePublicDetails", data: { token } })
            .get<LeadJobDetailPublicResponse>();
        return result;
    },
};
